import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Constants } from '../../../../app.constants';
import { RouterUrls } from '../../../../shared/router-urls';
import { ApiService } from '../../../../services/api.service';
import { LanguageService } from 'src/app/services/language.service';
import { isMobile } from '../../../../utils/screen.utils';
import { ModalService } from '../../../../shared/services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { VolunteeringService } from 'src/app/services/volunteering.service';
import { User } from '../../../../shared/user.model';
import { ModalConstants } from '../../../../shared/services/modal/modal.constants';
import {
  ExternalMissionWorkingHoursConfirmationModalComponent
} from '../external-mission-working-hours-confirmation-modal/external-mission-working-hours-confirmation-modal.component';

@Component({
  selector: 'app-external-mission-modal',
  templateUrl: './external-mission-modal.component.html',
  styleUrls: ['./external-mission-modal.component.scss']
})
export class ExternalMissionModalComponent implements OnInit {
  readonly Constants = Constants;
  RouterUrls = RouterUrls;

  ioName: string;
  ioNameEn: string;
  externalLink: string;
  endsWithS: boolean;
  isChecked: boolean;
  missionId: number;
  user: User;
  company: string;

  screenWidth: number;

  constructor(private dialogRef: MatDialogRef<ExternalMissionModalComponent>,
              @Inject(MAT_DIALOG_DATA) public application: any,
              private modal: ModalService, @Inject(MAT_DIALOG_DATA) data,
              private translate: TranslateService,
              private apiService: ApiService,
              private languageService: LanguageService,
              private volunteeringService: VolunteeringService
  ) {
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.ioName = this.application.ioName;
    this.endsWithS = this.ioName.slice(-1).toLowerCase() === 's';
    this.externalLink = this.application.externalLink;
    this.missionId = this.application.missionId;
    this.user = this.application.user;
    this.company = this.application.company;
    this.ioNameEn = !this.endsWithS ? this.ioName + '’s' : this.ioName + '’';
  }

  checkTrustCheckbox(): void {
    this.isChecked = !this.isChecked;
  }

  openIOWebsite(url: string) {
    const data = {
      account_id: this.user.id,
      offer_id: this.missionId
    };
    this.apiService.newExternalClick(data).subscribe();
    window.open(url, '_blank');
  }

  openConfirmWorkingHoursModal() {
    var applicationData = {
      offer_id: this.missionId,
      user: this.user,
      external: true
    }

    const modalHeight = isMobile() ? 321 : 338;
    const modalWidth = isMobile() ? 320 : 494;

    const confirmationModal = this.modal.openAdaptableModal(
      {}, ExternalMissionWorkingHoursConfirmationModalComponent,
      isMobile() ? ModalConstants.NO_PADDING_PANEL_CLASS : ModalConstants.NO_PADDING_PANEL_CLASS,
      modalWidth, modalHeight, modalWidth);
    confirmationModal.componentInstance.applicationData = applicationData;

    this.closeDialog(true);
  }


  closeDialog(reloadView: boolean) {
    this.dialogRef.close(reloadView);
  }

  protected readonly isMobile = isMobile;
}
